"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
//import Divider from '@mui/material/Divider';
require("../../assets/styles/message.css");
function ChatMessage(props) {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h5", { className: "messageOwner" }, props.sender),
        react_1.default.createElement("div", { className: "messageDiv" },
            react_1.default.createElement("p", null,
                props.message,
                " "))));
}
ChatMessage.propTypes = {};
exports.default = ChatMessage;
